import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";
import { removeBonusCardRequestedState } from "@/services/bonusCard.service";
import * as SoftLoginService from "@/services/softLogin.service";
import { StoreService } from "@/services/store.service";

import { StorageKeys } from "./enums";

export function logoutCleanUp(): void {
    let { email } = SoftLoginService.getSoftLoginDetails();
    if (!email) {
        email = SessionStorage.getItem(StorageKeys.GuestEmail);
    }
    SoftLoginService.clearSoftLogin();
    StoreService.cleanUpPreferredStores();
    AlgoliaTrackingService.logout();
    if (email) {
        removeBonusCardRequestedState(email);
    }
}
